import filter from 'lodash/filter';
import find from 'lodash/find';
import get from 'lodash/get';

import {
    getFollowedCollections as getFollowedCollectionsApi,
    followCollection as followCollectionApi,
    unfollowCollection as unfollowCollectionApi,
    getCollectionsForPlace as getCollectionsForPlaceApi,
    getCollectionsForOnline as getCollectionsForOnlineApi,
} from './api';

import {
    SET_COLLECTIONS,
    UPDATE_COLLECTION,
    CLEAR_COLLECTIONS,
} from './actionTypes';

import { transformCollectionResponse } from './utils';

export const clearCollections = () => ({
    type: CLEAR_COLLECTIONS,
});

export const setCollections = (data, customActionType) => ({
    type: customActionType || SET_COLLECTIONS,
    payload: data,
});

export const updateCollection = (data) => ({
    type: UPDATE_COLLECTION,
    payload: data,
});

export const getCollectionsForPlace = ({
    placeId,
    collectionsToShow,
    customActionType,
}) => (dispatch) => {
    const queryCallback = (response) => {
        let filteredEntities = [];

        filteredEntities = filter(response.collections, (collection) => {
            return find(
                collectionsToShow,
                (collectionToShow) => collectionToShow === collection.id,
            );
        });
        response.collections = filteredEntities;

        const {
            entities,
            hasMoreItems,
            continuation,
        } = transformCollectionResponse(response);

        dispatch(
            setCollections(
                {
                    entities,
                    hasMoreForPlace: hasMoreItems,
                    continuationForPlace: continuation,
                },
                customActionType,
            ),
        );
    };
    if (collectionsToShow) {
        if (placeId) {
            return getCollectionsForPlaceApi(placeId).then(
                queryCallback,
                /**
                 * None calls were catching the errors and we don't have something to
                 * do when the api fails right now besides failing so we silence the
                 * error.
                 */
                () => {},
            );
        } else {
            return getCollectionsForOnlineApi().then(
                queryCallback,
                /**
                 * None calls were catching the errors and we don't have something to
                 * do when the api fails right now besides failing so we silence the
                 * error.
                 */
                () => {},
            );
        }
    }
};

export const getFollowedCollections = (userId, continuation = null) => (
    dispatch,
) =>
    getFollowedCollectionsApi(userId, continuation).then((response) => {
        const {
            entities,
            hasMoreItems,
            continuation,
        } = transformCollectionResponse(response);

        dispatch(
            setCollections({
                entities,
                hasMoreFollowed: hasMoreItems,
                continuationFollowed: continuation,
            }),
        );
    });

export const followCollection = (collectionId) => (dispatch, getState) => {
    const { collections: { entities = {} } = {} } = getState();

    return followCollectionApi(collectionId).then(() =>
        dispatch(
            updateCollection({
                id: collectionId,
                followStatus: {
                    ...get(entities, [collectionId, 'followStatus'], {}),
                    followedByYou: true,
                    /* Chance may be incorrect relative to server but
                            updating to provide user with immediate feedback on action.*/
                    numFollowers:
                        get(
                            entities,
                            [collectionId, 'followStatus', 'numFollowers'],
                            0,
                        ) + 1,
                },
            }),
        ),
    );
};

export const unfollowCollection = (collectionId) => (dispatch, getState) => {
    const { collections: { entities = {} } = {} } = getState();

    return unfollowCollectionApi(collectionId).then(() =>
        dispatch(
            updateCollection({
                id: collectionId,
                followStatus: {
                    ...get(entities, [collectionId, 'followStatus'], {}),
                    followedByYou: false,
                    /* Chance may be incorrect relative to server but
                            updating to provide user with immediate feedback on action.*/
                    numFollowers:
                        get(
                            entities,
                            [collectionId, 'followStatus', 'numFollowers'],
                            1,
                        ) - 1,
                },
            }),
        ),
    );
};
